var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-loader",class:{'btn-loading': _vm.sending},attrs:{"type":"submit","disabled":_vm.disabled}},[_c('svg-loader'),_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }